import type { CompleteMicroSegmentationResult } from '../types/segmentationTypes'
import { useAnchoredRowsStore } from '../store/anchoredRowsStore'
import { reconcileLedgerSafeBoundaryEdit } from './ledgerSafeBoundaryReconcile'

export const syncWitnessSegmentationToAnchoredRows = async ({
  chapterId,
  witnessId,
  previousSegmentationResult,
  nextSegmentationResult
}: {
  chapterId: string
  witnessId: string
  previousSegmentationResult: CompleteMicroSegmentationResult | null | undefined
  nextSegmentationResult: CompleteMicroSegmentationResult | null | undefined
}): Promise<{ changedRowIds: string[] }> => {
  if (!chapterId || !witnessId || !nextSegmentationResult) {
    return { changedRowIds: [] }
  }

  const anchoredRowsStore = useAnchoredRowsStore.getState()
  const rows = await anchoredRowsStore.loadChapterRows(chapterId)
  if (!rows.some(row => row.unitMappings.some(mapping => mapping.witnessId === witnessId && !mapping.excluded))) {
    return { changedRowIds: [] }
  }

  const reconcileResult = reconcileLedgerSafeBoundaryEdit({
    witnessId,
    previousSegmentationResult,
    nextSegmentationResult,
    rows
  })
  const changedRows = reconcileResult.updatedRows.filter(row => reconcileResult.changedRowIds.includes(row.id))
  if (changedRows.length === 0) {
    return { changedRowIds: [] }
  }

  await anchoredRowsStore.upsertRows(chapterId, changedRows, { autoRelabel: false })
  return { changedRowIds: reconcileResult.changedRowIds }
}
